import $ from "jquery";
import React, { useState } from "react";
import Loader from "../../UI/loader";
import clientConfigApi from '../../../config/config';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next'
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { CARD_CAN_BE_CHARGED, CARD_DEMO, CMSPath, DEMO } from "../../../config/constant";
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { getDefaultAnalyticsLabel, validateEmail } from '../../JS/utility';
import { setCardStatusPopupProps, setCheckinCurrentPageName } from '../../action/autoCheckin';


const Shift4Container = (props) => {

    const { t } = props

    const [showLoader, setShowLoader] = React.useState(false)
    const [postalCode, setPostalCode] = React.useState(null)
    const [email, setEmail] = React.useState(props.email || "")
    const [lastName, setLastName] = React.useState(props.lastName || "");
    const [firstName, setFirstName] = React.useState(props.firstName || "");
    const [cardDetailsContainer, setCardDetailsContainer] = React.useState(false)


    const handleShift4Response = (response, status) => {

        window.removeEventListener("message", ListenMessageListner, false);

        setCardDetailsContainer(false)
        setShowLoader(true)
        $(".clear-iframe-container").attr("style", "")

        if (status == "success") {

            clientConfigApi.post("/mobileCheckIn/cardValidation", {
                "header": {
                    "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                    "actionKey": "register"
                },
                "payload": {
                    "confirmationNumber": props.confirmationNumber,
                    "email": email
                }
            }).then(res => {
                if (res.data.payload.tokenStr) {

                    clientConfigApi.post("/mobileCheckIn/cardValidation", {
                        "header": {
                            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                            "actionKey": "checks"
                        },
                        "payload": {
                            "confirmationNumber": props.confirmationNumber,
                            "firstNameCard": firstName,
                            "lastNameCard": lastName,
                            "postalCode": postalCode,
                            "customerId": res.data.payload.tokenStr,
                            "cardToken": response.id
                        }
                    })
                        .then((resp) => {

                            if (resp.data.header.status.code == "SUCCESS") {
                                props.showFailScreen(false);
                                setShowLoader(false);
                                props.setCardStatusPopupProps({
                                    cardStatus: true,
                                    statusTitle: 'Success',
                                    statusMessage1: 'Card verified successfully',
                                    statusMessage2: 'Please proceed to next steps'
                                })
                                props.showCardVerified({firstName: firstName, lastName: lastName})
                                localStorage.setItem("cardVerfied", true)

                                // Send Analytics
                                let label = {
                                    "dateTime": new Date,
                                    "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
                                    "Room": localStorage.getItem("room") || "",
                                    "sourceApp": "guestJourneyApp",
                                    "layoutTab": props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                                props.sendAnalytics(
                                    null,
                                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                                    "CREDIT CARD DETAILS - SUCCESS",
                                    label,
                                    0,
                                    false
                                );

                            } else {
                                props.showFailScreen(true, "Unable to update card in the reservation. Please try agian or contact Front Desk");
                                setShowLoader(false)
                                if (window.FirebasePlugin) {
                                    window.FirebasePlugin.logError("Unable to update card in the reservation.", resp)
                                }

                                // Send Analytics
                                let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Card verification failed"
                                let label = {
                                    "dateTime": new Date,
                                    "errorMessage": failedReason,
                                    "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
                                    "Room": localStorage.getItem("room") || "",
                                    "sourceApp": "guestJourneyApp",
                                    "layoutTab": props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                                props.sendAnalytics(
                                    null,
                                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                                    "CREDIT CARD DETAILS - FAILED",
                                    label,
                                    0,
                                    false
                                );
                            }
                        })
                        .catch((err) => {
                            props.showFailScreen(true, "Unable to update card in the reservation. Please try agian or contact Front Desk");
                            setShowLoader(false)
                            if (window.FirebasePlugin) {
                                window.FirebasePlugin.logError("Unable to update card in the reservation.", err.response)
                            }

                            // Send Analytics
                            let failedReason = err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                            let label = {
                                "dateTime": new Date,
                                "errorMessage": failedReason,
                                "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
                                "Room": localStorage.getItem("room") || "",
                                "sourceApp": "guestJourneyApp",
                                "layoutTab": props.currentHomePage.tabName,
                                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                            }
                            props.sendAnalytics(
                                null,
                                props.currentWidgetObj.widgetType || "Mobile Check-in",
                                "CREDIT CARD DETAILS - FAILED",
                                label,
                                0,
                                false
                            );
                        })
                }
                else {
                    setShowLoader(false);
                    props.showFailScreen(true, res.data && res.data.header && res.data.header.status.msg || "Card verification failed");
                    if (window.FirebasePlugin) {
                        window.FirebasePlugin.logError("Card validation api failed CMS: ", response.data.header.status.msg)
                    }

                    // Send Analytics
                    let failedReason = res.data && res.data.header && res.data.header.status.msg || "Card verification failed"
                    let label = {
                        ...getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" }),
                        "dateTime": new Date,
                        "errorMessage": failedReason, "layoutTab": props.currentHomePage.tabName,
                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                    }
                    props.sendAnalytics(
                        null,
                        props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CREDIT CARD DETAILS - FAILED",
                        label,
                        0,
                        false
                    );
                    //
                }

            }).catch(err => {
                setShowLoader(false);
                props.showFailScreen(true, err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed");
                if (window.FirebasePlugin) {
                    window.FirebasePlugin.logError("Card validation api failed CMS: ", err.response.data.header.status.msg)
                }

                // Send Analytics
                let failedReason = err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                let label = {
                    ...getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" }),
                    "dateTime": new Date,
                    "errorMessage": failedReason, "layoutTab": props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }
                props.sendAnalytics(
                    null,
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CREDIT CARD DETAILS - FAILED",
                    label,
                    0,
                    false
                );
            });
        } else if (status == "close") {
            setShowLoader(false)

        } else {
            props.showFailScreen(true, response);
            setShowLoader(false)
            if (window.FirebasePlugin) {
                window.FirebasePlugin.logError("Error at card validation elavon: ", response)
            }


            // Send Analytics
            let failedReason = status != "success" ? response || "Card verification error" : ""
            let label = {
                "dateTime": new Date,
                "errorMessage": status != "success" ? failedReason : "",
                "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
                "Room": localStorage.getItem("room") || "",
                "sourceApp": "guestJourneyApp",
                "layoutTab": props.currentHomePage.tabName,
                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
            }
            props.sendAnalytics(
                null,
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                status == "success" ? "CREDIT CARD DETAILS - SUCCESS" : "CREDIT CARD DETAILS - FAILED",
                label,
                0,
                false
            );
        }
    }

    const ListenMessageListner = (e) => {
        if (e.data && JSON.parse(e.data) && JSON.parse(e.data).status) {
            handleShift4Response(JSON.parse(e.data).response, JSON.parse(e.data).status);
        }
    }

    const handleNext = () => {

        if (!firstName) {
            props.popupOpenClose(true, "Please enter your first name");
            return;
        }
        if (!lastName) {
            props.popupOpenClose(true, "Please enter your last name");
            return;
        }
        if (!email) {
            props.popupOpenClose(true, "Please enter your email");
            return;
        }
        if (!validateEmail(email)) {
            props.popupOpenClose(true, "Please enter a valid email address");
            return;
        }


        props.setCheckInAddress({ postalCode: postalCode })

        if (CARD_DEMO) {
            setShowLoader(true);

            setTimeout(() => {
                setShowLoader(false);

                props.setCardStatusPopupProps({
                    cardStatus: true,
                    statusTitle: 'Success',
                    statusMessage1: 'Card verified successfully',
                    statusMessage2: 'Please proceed to next steps'
                })
                props.showCardVerified({firstName: firstName, lastName: lastName})
                localStorage.setItem('cardVerfied', true)

                let label = {
                    "dateTime": new Date,
                    "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
                    "Room": localStorage.getItem("room") || "",
                    "sourceApp": "guestJourneyApp",
                    "layoutTab": props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }
                props.sendAnalytics(
                    null,
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CREDIT CARD DETAILS - SUCCESS",
                    label,
                    0,
                    false
                );

            }, 1500)
            return;
        }

        setCardDetailsContainer(true)
        window.addEventListener("message", ListenMessageListner);
    }

    React.useEffect(() => {

        props.checkInAddress.postalCode && setPostalCode(props.checkInAddress.postalCode)
        props.setCheckinCurrentPageName("CREDIT CARD DETAILS")

        return () => {
            window.removeEventListener("message", ListenMessageListner, false);
        };
    }, [])

    return (
        <div className='shift4-iframe-container'>
            {cardDetailsContainer
                ? <iframe frameborder="0" onLoad={() => {
                    $(".shift4-container").attr("style", "width: 100%; height: 100%")
                    $(".shift4-iframe-container").attr("style", "position: absolute; top: 0; left: 0; width: 100vw; height: 100vh; background: #fff")
                    setShowLoader(false)
                }} style={{ width: 0, height: 0 }} className='shift4-container' src={`https://guest-journey.s3.amazonaws.com/static/shift4.html?publicKey=${props.publicKey}`}></iframe>
                :
                <div>
                    <header className="inner-pages w-footer subpages">
                        <a className="button-back" onClick={props.backBtn}></a>
                        <div className="heading align-center">
                            <div class="splash-brand">
                                <img src={`${CMSPath}${props.logo}`} />
                            </div>
                            {/* <p className="bold" style={{ color: "inherit" }}>{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                        </div>
                    </header>
                    <section className="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner">
                        { props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    </div>

                        <div className="widgets">
                            <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                <h2>{t('check_in.booking_details')}</h2>
                            </div>
                            {!(localStorage.getItem('cardVerfied') == 'true') ?


                                <div className="form-window">
                                    <div className="form-window-heading">
                                        {t('check_in.card_details')}
                                    </div>
                                    <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                        <p>{CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : t('check_in.enter_details')} </p>

                                        <div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="firstName">First Name <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="firstName"
                                                    autoComplete='given-name'
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                    value={firstName}
                                                    type="text"
                                                    placeholder="First Name" />
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="lastName">Last Name <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="lastName"
                                                    autoComplete='family-name'
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    value={lastName}
                                                    type="text"
                                                    placeholder="Last Name" />
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="address">Email <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="address"
                                                    autoComplete='email'
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    value={email}
                                                    placeholder="Email"
                                                    type="text" />
                                            </div>
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label for="postalCode">Postal Code</label>
                                                <input
                                                    name="postalCode"
                                                    autoComplete='postal-code'
                                                    onChange={(e) => setPostalCode(e.target.value)}
                                                    value={postalCode}
                                                    placeholder="Postal Code"
                                                    />
                                            </div>
                                        </div>

                                        <div className="form-controls">
                                            <button className="primary w-100" onClick={() => handleNext()} >Continue</button>
                                        </div>
                                        {DEMO && <input class="card-skip" onClick={() => props.next({firstName: firstName, lastName: lastName})} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}
                                    </div>
                                </div>
                                :
                                <div class="form-window">
                                    <div class="form-window-heading">
                                        Card verified
                                    </div>
                                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                        <div class="form-row margin-bottom-1">
                                            <p>Your card was successfully verified.</p> {/* **** **** **** 4242  */}
                                            <p>Tap on NEXT to proceed</p>
                                        </div>
                                        <div class="form-controls">
                                            {/* <button class="secondary w-100 margin-bottom-1">Change card</button>  */}
                                            <button className="primary w-100" onClick={() => props.next({firstName: firstName, lastName: lastName})}>{t('check_in.next')}</button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </section>
                </div>}
            {showLoader && <Loader displayMsg="Verifying data..." />}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        checkInAddress : state.store2.checkInAddress,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, popupOpenClose, setCardStatusPopupProps, setCheckinCurrentPageName, setCheckInAddress, sendAnalytics, getDefaultAnalyticsLabel })(withTranslation('translations')(Shift4Container));